import { Stack, useLocalSearchParams, useRouter } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import { usePressableAnalytics } from 'shared/hooks/analytics/usePressableAnalytics';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import { useBackHandler } from 'shared/hooks/useBackHandler/useBackHandler';
import ActionScreen from 'shared/patterns/vxl/ActionScreen/ActionScreen';

const BelieveReviewScreen = () => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('believe', {
    keyPrefix: 'reviewPageString',
  });
  const { isBelieveDay0M2 } = useLocalSearchParams<{
    isBelieveDay0M2: string;
  }>();
  const subcategory =
    isBelieveDay0M2 === 'true'
      ? 'believe_day_0_application'
      : 'believe_application';

  useViewDidFocusScreenAnalyticsEvent({
    key: 'believeReview',
    customAttributes: { subcategory },
  });

  const handleDoneAnalytics = usePressableAnalytics({
    analyticsId: 'done',
    customAttributes: { subcategory },
  });

  const backToHome = () => {
    if (router.canGoBack()) {
      router.dismissAll();
    }
    router.back();
  };

  useBackHandler(backToHome);

  const handleAnalyticsAndRedirect = () => {
    handleDoneAnalytics();
    backToHome();
  };

  return (
    <>
      <Stack.Screen
        options={{
          headerShown: false,
          gestureEnabled: false,
        }}
      />

      <ActionScreen
        titleText={translatedText('title')}
        titleTextStyle="extra-large"
        visual="MAGNIFY_A"
        bodyContent={<BodyBaseText>{translatedText('subtitle')}</BodyBaseText>}
        primaryButton={{
          label: translatedText('doneButton'),
          onPress: function (): void {
            handleAnalyticsAndRedirect();
          },
        }}
      />
    </>
  );
};

export default BelieveReviewScreen;
